import { render } from "./message-center.vue?vue&type=template&id=64a14a0e"
import script from "./message-center.vue?vue&type=script&lang=js"
export * from "./message-center.vue?vue&type=script&lang=js"

import "./message-center.vue?vue&type=style&index=0&id=64a14a0e&lang=scss"

import exportComponent from "/Users/chenjun/Desktop/myProject/pbl-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__